export enum NoteTypes {
    General = 1,
    Medical = 2,
    DataMigration = 3,
    Vaccination = 4,
    Medication = 5,
    PetProfile = 6,
    ClientProfile = 7,
    Invoice = 8
}
